import { TypedDispatch } from "src";
import { Notification, Resident, Sound } from "src/common/types";
import { playSound } from "../../common/lib/sounds";

export const pushNotification =
  (notification: Notification) => (dispatch: TypedDispatch) => {
    if (notification.status === "ERROR" && !notification.sound) {
      playSound(Sound.SorryError);
    } else if (notification.sound) {
      playSound(notification.sound);
    }

    dispatch({ type: "PUSH_NOTIFICATION", notification });

    setTimeout(() => {
      dispatch({ type: "POP_NOTIFICATION" });
    }, 5000);
  };

export const handleDeviceOffline = () => ({
  type: "DEVICE_OFFLINE",
});

export const handleDeviceOnline = () => ({
  type: "DEVICE_ONLINE",
});

export const incrementRecentCall = (resident: Resident) => ({
  type: "INCREMENT_RECENT_CALL",
  resident,
});

export const decrementRecentCall = (resident: Resident) => ({
  type: "DECREMENT_RECENT_CALL",
  resident,
});
